import { useRoutes } from 'react-router'
import { routes } from './router/index.ts'

export function App() {
  const element = useRoutes(routes)
  return <>{element}</>
}
